module.exports = __webpack_public_path__ + "static/media/view-demo-2.0eb9ebed.png";